module.exports = __webpack_public_path__ + "img/norecord.d69113d1.png";